<template>
  <div>
    <div v-if="!clipsWithSelection.length" class="text-white mt-4">
      Your clips will be listed here
    </div>

    <ul v-else class="list-none overflow-auto max-h-full p-0 m-0 space-y-3">
      <video-editor-clip-list-item
        v-for="item in clipsWithSelection"
        :key="item.clip.id"
        :clip="item.clip"
        :is-selected="item.isSelected"
        :preview-aspect-ratio="previewAspectRatio"
      />
    </ul>
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const videoEditorStore = useVideoEditorStore();
  const {clips, file, videoElement, activeEditClipId} = storeToRefs(videoEditorStore);
  const DEFAULT_PREVIEW_ASPECT_RATIO = 16 / 9;

  const previewAspectRatio = computed(() => {
    const fileWidth = Number(file.value?.width);
    const fileHeight = Number(file.value?.height);
    if (Number.isFinite(fileWidth) && Number.isFinite(fileHeight) && fileWidth > 0 && fileHeight > 0) {
      return fileWidth / fileHeight;
    }

    const videoWidth = Number(videoElement.value?.videoWidth);
    const videoHeight = Number(videoElement.value?.videoHeight);
    if (Number.isFinite(videoWidth) && Number.isFinite(videoHeight) && videoWidth > 0 && videoHeight > 0) {
      return videoWidth / videoHeight;
    }

    return DEFAULT_PREVIEW_ASPECT_RATIO;
  });

  const normalizedActiveEditClipId = computed(() => {
    if (activeEditClipId.value === null || activeEditClipId.value === undefined) {
      return null;
    }

    return String(activeEditClipId.value);
  });

  const clipsWithSelection = computed(() =>
    (clips.value || []).map(clip => ({
      clip,
      isSelected: normalizedActiveEditClipId.value !== null
        && String(clip?.id) === normalizedActiveEditClipId.value
    }))
  );
</script>
